import { useLocation, useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { GuardProps } from 'types';
import { useEffect, useRef } from 'react';
import return_to from 'utils/route-guard/return_to';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }: GuardProps) => {
    const { isLoggedIn } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    // logged in when mounted: losing it is a logout, no page to return to
    let was_logged_in = useRef(isLoggedIn);

    useEffect(() => {
        if (!isLoggedIn) {
            navigate(was_logged_in.current ? '/login' : return_to.login_url_get_e({loc: location}), { replace: true });
        }
    }, [isLoggedIn, navigate]);

    return children;
};

export default AuthGuard;
